import { takeLatest, put } from 'redux-saga/effects'
import { FETCH_USER_DATA, SET_IS_LOADING, SIGN_IN, SIGN_IN_FAIL, SignInActionType } from 'dealer-reducers'
import { AuthenticationDetails, CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js'
import userPool from 'src/helpers/userPool'
import { getDeviceId } from 'src/helpers/deviceId'

export const authenticate = async (Email: string, Password: string): Promise<CognitoUserSession> => {
  return await new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: Email,
      Pool: userPool
    })

    const authDetails = new AuthenticationDetails({
      Username: Email,
      Password
    })

    user.authenticateUser(authDetails, {
      onSuccess: (result) => {
        resolve(result)
      },
      onFailure: (err) => {
        reject(err)
      }
    })
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* SignInFlow(action: SignInActionType): Generator<any, void, any> {
  try {
    yield put(SET_IS_LOADING(true))
    yield authenticate(action.payload.email, action.payload.password)
    localStorage.setItem('dealer_email', action.payload.email)
    getDeviceId()
    yield put(FETCH_USER_DATA())
  } catch (error) {
    yield put(SIGN_IN_FAIL())
  } finally {
    yield put(SET_IS_LOADING(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* SignIn(): Generator<any, void, any> {
  yield takeLatest([SIGN_IN], SignInFlow)
}
